import type { TExposedCompanyDTO } from '@doutorsim/shared/exposed/companies'
import { createContext, useContext } from 'react'

const CompanyContext = createContext<TExposedCompanyDTO | null>(null)

export const CompanyProvider = CompanyContext.Provider

export function useCompanyContext(): TExposedCompanyDTO | null {
  return useContext(CompanyContext)
}
